import { getV1CompaniesCompanyIdTwilioIntegrations } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { useState } from 'react';

import connection from '~services/connectionModule';

import { TwilioIntegration } from './models';

export const useTwilioIntegrations = () => {
  const [isLoading, setIsLoading] = useState(false);

  const getTwilioIntegrations = async (companyId: string) => {
    setIsLoading(true);
    try {
      const response = await getV1CompaniesCompanyIdTwilioIntegrations({
        path: { 'company-id': companyId },
      });
      return response.data.data.map(TwilioIntegration.parse);
    } catch (error) {
      connection.handleRequestError(
        error,
        t('error_messages.agents.failed_to_fetch_agents'),
      );
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, getTwilioIntegrations };
};
